import React from "react";
import { cn } from "../lib/helpers";

import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

import Menu from "./menu/menu";
import Header from "./header";
import Footer from "./footer";

import * as styles from "./layout.module.css";
import * as commonStyles from "../styles/common.module.css";

function gtag() {
  window.dataLayer.push(arguments);
}
class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scrolled: false,
    };
  }

  componentDidMount() {
    window.dataLayer = window.dataLayer || [];
    document.body.style.overflow = "inherit";
    gtag("consent", "default", {
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
      analytics_storage: "denied",
    });

    CookieConsent.run({
      categories: {
        analytics: {
          services: {
            ga: {
              label: "Google Analytics",
              onAccept: () => {
                document.cookie = "gatsby-gdpr-google-analytics=true; SameSite=Strict;";
                gtag("consent", "update", {
                  analytics_storage: "granted",
                });
              },
              onReject: () => () => {
                document.cookie = "gatsby-gdpr-google-analytics=false; SameSite=Strict;";
              },
              cookies: [
                {
                  name: "gatsby-gdpr-google-analytics",
                },
                {
                  name: /^(_ga|_gid)/,
                },
              ],
            },
          },
        },
        advertisement: {
          services: {
            gads: {
              label: "Google Ads",
              onAccept: () => {
                gtag("consent", "update", {
                  ad_storage: "granted",
                  ad_user_data: "granted",
                  ad_personalization: "granted",
                });
                document.cookie = "gatsby-gdpr-google-tagmanager=true; SameSite=Strict;";
              },
              onReject: () => () => {
                document.cookie = "gatsby-gdpr-google-tagmanager=false; SameSite=Strict;";
              },
              cookies: [
                {
                  name: "gatsby-gdpr-google-tagmanager",
                },
                {
                  name: /^(_gid|_ga.*)/,
                },
              ],
            },
            fp: {
              label: "Facebook Pixel",
              onAccept: () => {
                document.cookie = "gatsby-gdpr-facebook-pixel=true; SameSite=Strict;";
              },
              onReject: () => () => {
                document.cookie = "gatsby-gdpr-facebook-pixel=false; SameSite=Strict;";
              },
              cookies: [
                {
                  name: "gatsby-gdpr-facebook-pixel",
                },
                {
                  name: /^(_fbp)/,
                },
              ],
            },
          },
        },
      },

      language: {
        default: "cs",
        translations: {
          cs: {
            consentModal: {
              title: "Používáme cookies",
              description:
                "Používáme analytické a marketingové cookies. Svůj souhlas můžete kdykoli odvolat v nastavení cookies v patičce. Podrobnosti o zpracování osobních údajů naleznete v našich Zásadách ochrany osobních údajů.",
              acceptAllBtn: "Přijmout vše",
              acceptNecessaryBtn: "Odmítnout vše",
              showPreferencesBtn: "Spravovat jednotlivé souhlasy",
            },
            preferencesModal: {
              title: "Spravovat cookies",
              acceptAllBtn: "Přijmout vše",
              acceptNecessaryBtn: "Odmítnout vše",
              savePreferencesBtn: "Přijmout vybrané",
              closeIconLabel: "Zavřít okno",
              sections: [
                {
                  title: "Analytické",
                  description: "Pro statistiky návštěvnosti.",
                  linkedCategory: "analytics",
                },
                {
                  title: "Marketingové",
                  description: "Pro personalizovanou reklamu.",
                  linkedCategory: "advertisement",
                },
                {
                  title: "Více informací",
                  description:
                    'Pro více informací nás můžete <a href="/konzultace">kontaktovat přes kontaktní formulář.</a>',
                },
              ],
            },
          },
        },
      },
    });
  }

  render() {
    const { children, logoAnimation, services, magazin, tags } = this.props;
    return (
      <div className={cn(styles.container, commonStyles.fadeIn)}>
        <Menu services={services} tags={tags} />
        <Header logoAnimation={logoAnimation} />
        <div>{children}</div>
        <Footer services={services} magazin={magazin} />
      </div>
    );
  }
}

export default Layout;
